import { render, staticRenderFns } from "./inboundBatchInventory.vue?vue&type=template&id=49494cf8&scoped=true&"
import script from "./inboundBatchInventory.vue?vue&type=script&lang=tsx&"
export * from "./inboundBatchInventory.vue?vue&type=script&lang=tsx&"
import style0 from "./inboundBatchInventory.vue?vue&type=style&index=0&id=49494cf8&lang=scss&scoped=true&"
import style1 from "./inboundBatchInventory.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49494cf8",
  null
  
)

export default component.exports